import { COLORS } from "../../utils/Colors";

interface BadgeProps {
  text: string;
  color: string;
  textColor?: string;
  variant?: "solid" | "outline" | "subtle";
  children?: React.ReactNode;
  size?: "xsm" | "sm" | "md" | "lg";
  style?: React.CSSProperties;
}

export const Badge = ({
  text,
  color,
  textColor,
  variant = "solid",
  children,
  size = "md",
  style,
}: BadgeProps) => {
  const getContainerStyles = () => {
    const baseStyles = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "12px",
      fontWeight: "600",
      fontSize: "13px",
      letterSpacing: "0.025em",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      whiteSpace: "nowrap" as const,
      cursor: "default",
      border: "1px solid transparent",
      padding:
        size === "xsm"
          ? "0px 2px"
          : size === "sm"
            ? "4px 8px"
            : size === "lg"
              ? "12px 16px"
              : "8px 10px",
      minWidth: "100px",
    };

    const variantStyles = {
      solid: {
        backgroundColor: color,
        borderColor: color,
        color: textColor || COLORS.Text.Inverse,
        boxShadow: `0 1px 3px 0 ${color}25, 0 1px 2px 0 ${color}15`,
      },
      outline: {
        backgroundColor: "transparent",
        borderColor: color,
        color: color,
        boxShadow: "none",
      },
      subtle: {
        backgroundColor: `${color}15`,
        borderColor: `${color}30`,
        color: color,
        boxShadow: "none",
      },
    };

    return {
      ...baseStyles,
      ...variantStyles[variant],
    };
  };

  return (
    <div style={{ ...getContainerStyles(), ...style }}>
      {children && <div style={{ marginRight: "8px" }}>{children}</div>}
      {text.charAt(0).toUpperCase() + text.slice(1)}
    </div>
  );
};
